export default class WooCommerceButtons {
  constructor() {
    this.getDomElements()
    this.icon = '<ion-icon class="u-icon u-icon--small u-mr-half" name="basket"></ion-icon>'

    if (!this.dom.button) return

    this.init()
  }

  init() {
    this.addIcon()
  }

  getDomElements() {
    this.dom = {
      button: document.querySelector('button[type="submit"].button.single_add_to_cart_button'),
    }
  }

  addIcon() {
    this.dom.button.innerHTML = this.icon + this.dom.button.innerHTML
  }
}